import React, { useRef, Component } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { DownloadIcon, AlertTriangleIcon, AnchorIcon } from 'lucide-react';
import { WaveDivider } from './WaveDivider';
export function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const steps = [{
    icon: DownloadIcon,
    number: '1',
    title: 'Descargas el Kit',
    description: 'Lo tienes en tu teléfono hoy mismo.'
  }, {
    icon: AlertTriangleIcon,
    number: '2',
    title: 'Identificas tus alertas',
    description: 'Aprendes a detectar el "Semáforo Amarillo" antes del colapso.'
  }, {
    icon: AnchorIcon,
    number: '3',
    title: 'Aplicas el Anclaje',
    description: 'Recuperas tu paz en medio del ruido mientras sigues trabajando.'
  }];
  return <section className="bg-slate-50 relative" data-id="element-62">
      <div ref={ref} className="py-16 md:py-24 px-4" data-id="element-63">
        <div className="max-w-4xl mx-auto" data-id="element-64">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6
        }} className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#0f1b2d] text-center mb-12" data-id="element-65">
            Cómo Funciona
          </motion.h2>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-66">
            {steps.map((step, index) => {
            const IconComponent = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 40
            }} animate={isInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              duration: 0.6,
              delay: 0.2 + index * 0.15
            }} className="text-center" data-id="element-67">
                  <div className="relative inline-block mb-6" data-id="element-68">
                    <div className="w-20 h-20 bg-gradient-to-br from-[#3d7a8a] to-[#6aacb8] rounded-full flex items-center justify-center shadow-lg" data-id="element-69">
                      <IconComponent className="w-10 h-10 text-white" data-id="element-70" />
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center text-white font-bold shadow-md" data-id="element-71">
                      {step.number}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-[#0f1b2d] mb-3" data-id="element-72">
                    {step.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-73">{step.description}</p>
                </motion.div>;
          })}
          </div>
        </div>
      </div>

      <WaveDivider fillColor="#1a2e4a" data-id="element-74" />
    </section>;
}